import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as R from 'ramda'

import domain from 'utils/domain'
import env from 'utils/env'

import sessionActions from 'actions/sessionActions'
import dataActions from 'actions/dataActions'
import attachmentsActions from 'actions/attachmentsActions'
import errorActions from 'actions/error'

import PouchAuth from 'components/drivers/PouchAuth'
import PouchSync from 'components/drivers/PouchSync'
import PouchRedux from 'components/drivers/PouchRedux'
import Loader from 'components/Loader'
import Login from 'components/Login'

let select = (state, props) => ({
	username: state.session.username
  , password: state.session.password
  , authenticated: state.session.authenticated
  , replicated: state.data.replicated
  , updated: state.data.updated
  , db: state.data.db
  , ready: state.data.idx
  , attachments: state.attachments
  , error: state.error
})

export let Auth = props => {
	let remote = `https://${domain}/${env}`
	let remoteAtt = `https://${domain}/${env}-attachments`
	let local = `${props.appName}-${env}`
	let localAtt = `${props.appName}-${env}-attachments`

	let showLogin =	!props.username || props.authenticated === false
	let showLoader = !showLogin && !props.ready
	let replicate = props.username != props.replicated

	return (
		<div>
			{!props.authenticated && props.username &&
				<PouchAuth
					db        = {remote}
					username  = {props.username}
					password  = {props.password}
					onSuccess = {props.LOGIN_OK}
					onFail    = {props.LOGIN_FAIL}
					onError   = {props.ERROR}
				/>
			}
			{props.authenticated &&
				<PouchSync
					db1        = {local}
					db2        = {remote}
					replicate  = {replicate}
					onDownload = {props.DATA_DOWNLOAD_OK}
					onSave     = {props.DATA_SAVE_OK}
					onUpdate   = {props.DATA_UPDATE_OK}
					onError    = {props.ERROR}
				/>
			}
			{props.authenticated &&
				<PouchSync
					db1     = {localAtt}
					db2     = {remoteAtt}
					oneWay  = {true}
					onError = {props.ERROR}
				/>
			}
			{props.updated &&
				<PouchRedux
					db       = {local}
					data     = {props.db}
					onLoad   = {props.DATA_LOAD_OK}
					onIndex  = {props.DATA_INDEX}
					onInsert = {props.DOC_EXTERNAL_UPDATE}
					onUpdate = {props.DOC_EXTERNAL_UPDATE}
					onDelete = {props.DOC_DELETE}
					onError  = {props.ERROR}
				/>
			}
			{props.updated &&
				<PouchRedux
					db      = {localAtt}
					data    = {props.attachments}
					onLoad  = {props.ATTACHMENTS_LOAD_OK}
					onError = {props.ERROR}
				/>
			}
			{showLoader &&
				<Loader />
			}
			{showLogin &&
				<Login />
			}
			{props.ready &&
				props.children
			}
		</div>
	)
}

export default connect(select, { ...sessionActions, ...dataActions, ...attachmentsActions, ...errorActions })(Auth)



// WEBPACK FOOTER //
// ./src/components/layouts/Auth.js